import React, { type SyntheticEvent, useEffect, useState } from "react";
import * as Styles from "./styles/MobileFooterStyles";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import Icon from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../../redux/store";
import { showMobileBasket } from "../../../../../../../common-deprecated/redux/actions/UtilActions";
import MobileBasket from "../basket/MobileBasket";
import BasketButton from "./BasketButton";
import { BnbLabel } from "../../../../utils/labels";
import { NavOrigin, NavStep } from "../../../../../shared-logic/utils/Navigation";
import FinanceInsuranceCalculatorLink from "../../../../utils/FinanceInsuranceCalculatorLink";
import { FINANCE_CALCULATOR } from "../../../../../../../common-deprecated/constants";
import { showModal } from "../../../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_FINANCE_TOGGLE } from "../../../../utils/modalConstants";
import { getMobileReachoutModalSize } from "../../../../../../../common-deprecated/utils";
import { trackBasketMobileOpen, trackFinanceToggle } from "../../../../utils/tracking";
import { useFinanceInsuranceNavigation } from "../../../../hooks/shared/useFinanceInsurance";
import { MobileNextButton } from "./MobileNextButton";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";

const MobileFooter = (): JSX.Element | null => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();

    const mobileBasketIsShown = useBnbSelector((state) => state.utils.showMobileBasket);
    const step = useBnbSelector((state) => state.navigation.step);
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const { showMonthlyRateCarConfig, showFinanceInsuranceInPage, enableFinanceCompare } = useBnbSelector(
        (state) => state.bnbSettings,
    );

    const [mobileReachoutHeight, setMobileReachoutHeight] = useState(0);

    const toggleBasketOpen = (event: SyntheticEvent): void => {
        event.preventDefault();
        if (!mobileBasketIsShown) trackBasketMobileOpen(step);
        dispatch(showMobileBasket(!mobileBasketIsShown));
    };

    const openCashToggleModal = (): void => {
        trackFinanceToggle(step, "cash", "cc-footer");
        dispatch(showModal({ type: MODAL_FINANCE_TOGGLE }));
    };

    useEffect(() => {
        // check if the injected reachout component is available
        if (getMobileReachoutModalSize()) {
            setMobileReachoutHeight(getMobileReachoutModalSize());
        }
    }, []);

    const { onClick, insuranceLabelKey } = useFinanceInsuranceNavigation(step);

    if (step === NavStep.Submodels || step === NavStep.Grades) return null;

    return (
        <>
            <Styles.Wrapper reachOutMobile={mobileReachoutHeight}>
                <Styles.Body>
                    <Styles.OpenToggle onClick={toggleBasketOpen}>
                        <Icon variant="chevronUp" />
                    </Styles.OpenToggle>

                    <BasketButton basketOpen={mobileBasketIsShown} toggle={toggleBasketOpen} />
                    <MobileNextButton step={step} financeOption={financeOption} />
                </Styles.Body>
                {showFinanceInsuranceInPage && enableFinanceCompare && showMonthlyRateCarConfig ? (
                    <Styles.PaymentControls>
                        <Styles.PaymentSwitch
                            type="button"
                            onClick={(event) => onClick(event, "cc-footer", NavOrigin.FinancialCta)}
                        >
                            <IconWrapper>
                                <Icon variant="finance" />
                            </IconWrapper>
                            <BnbLabel
                                label={financeOption === "monthly" ? "financeCollapsableTitle" : "financeButton"}
                            />
                        </Styles.PaymentSwitch>
                        <Styles.PaymentSwitch
                            type="button"
                            onClick={(event) => onClick(event, "cc-footer", NavOrigin.InsuranceCta)}
                        >
                            <IconWrapper>
                                <Icon variant="insurance" />
                            </IconWrapper>
                            <BnbLabel label={insuranceLabelKey} />
                        </Styles.PaymentSwitch>
                    </Styles.PaymentControls>
                ) : financeOption === "cash" ? (
                    <FinanceInsuranceCalculatorLink
                        type={FINANCE_CALCULATOR}
                        customButton={(props) => (
                            <Styles.PaymentSwitch
                                type="button"
                                onClick={() => {
                                    trackFinanceToggle(step, "monthly", "cc-footer");
                                    props.onClick(true);
                                }}
                            >
                                <BnbLabel label="financeOptionQuestionMonthly" />
                            </Styles.PaymentSwitch>
                        )}
                    />
                ) : (
                    showMonthlyRateCarConfig && (
                        <Styles.PaymentSwitch type="button" onClick={openCashToggleModal}>
                            <BnbLabel label="financeOptionQuestionCash" />
                        </Styles.PaymentSwitch>
                    )
                )}
            </Styles.Wrapper>

            {mobileBasketIsShown && <MobileBasket />}
        </>
    );
};
export default MobileFooter;
